
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Modal } from "@vwpfs/mary-air-lib/components/air/06-molecules/Modal";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { UserInfo } from "../../../../../store/AppTypes";
import { PolicyDetails } from "../../../../../store/Policies/Types";
import { ReduxState, isRemoteLoading } from "../../../../../store/ReduxState";
import { remoteTrigger, remoteClearResponse, remoteClearError } from "../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { ThemeSize } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalShow } from "../../../../../utils/redux/ActionTypes";
import { CancelPolicyModal } from "../../00-blocks/Policies/CancelPolicyModal";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { DetailView } from "./component/DetailView";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";


interface Params {
    policyId: string;
}

interface StateProps {
    params: Params;
    details: PolicyDetails;
    loading: boolean;
    user?: UserInfo;
}

interface DispatchProps {
    loadDetails?: (id: string) => void;
    clearDetails?: () => void;
    openCancelRequest?: (id: string) => void;
}

export type Props = DispatchProps & StateProps;

/**
 *
 */
export const mapStateToProps = (s: ReduxState, p: RouteComponentProps): StateProps => ({
    params: p.match.params as Params,
    details: s.prop("remote").prop(RemoteScope.POLICY_DETAILS),
    loading: isRemoteLoading(s, RemoteScope.POLICY_DETAILS),
    user: s.prop("user").isPresent() ? s.prop("user").get() : undefined,
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    loadDetails: (id: string) => dispatch(remoteTrigger(RemoteScope.POLICY_DETAILS, {
        id: id,
    })),
    clearDetails: () => (
        dispatch(remoteClearResponse(RemoteScope.POLICY_DETAILS)),
        dispatch(remoteClearError(RemoteScope.POLICY_DETAILS))
    ),
    openCancelRequest: (id: string) => dispatch(
        modalShow(
            "cancelpolicy" + id,
            () => (
                <Modal
                    modalID={"cancelpolicy" + id}
                    theme={{ size: ThemeSize.SMALL }}
                >
                    <CancelPolicyModal
                        modalID={"cancelpolicy" + id}
                        id={id}
                    />
                </Modal>
            ),
        ),
    ),
});

/**
 *
 */
export class DetailComp
    extends React.Component<Props, {}> {

    public constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        this.props.loadDetails?.(this.props.params.policyId);
    }

    public componentWillUnmount() {
        this.props.clearDetails?.();
    }

    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <DetailView {...this.props}/>
                </Container>
            </Page>
        );
    }
}

/**
 *
 */
export const Detail = connect(
    mapStateToProps,
    mapDispatchToProps,
)((props: Props) => <DetailComp {...props} />);
